import i18next from 'i18next'
import { z } from 'zod'
import translation from 'zod-i18n-map/locales/ja/zod.json'
import translationEn from 'zod-i18n-map/locales/en/zod.json'
import { zodI18nMap } from 'zod-i18n-map'
import { jaMessages } from './messages'
import { enMessages } from './messages_en'
import type { Locale } from '@/composables/useLocale'

const getLanguage = (): Locale => {
  const lang = navigator.language || 'en'
  if (lang.startsWith('ja')) return 'ja'
  return 'en'
}

i18next.init({
  lng: getLanguage(),
  fallbackLng: 'en',
  debug: import.meta.env.DEV,
  resources: {
    ja: {
      zod: translation,
      translation: {
        ...jaMessages
      }
    },
    en: {
      zod: translationEn,
      translation: {
        ...enMessages
      }
    }
  }
})
z.setErrorMap(zodI18nMap)

export default i18next
